import {AfterViewInit, ElementRef, Directive} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {AppComponent} from '../../app.component';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {ModalDirective} from "ngx-bootstrap";
import {Input} from "@angular/core";
import {EventEmitter} from "@angular/core";
import {OnInit} from "@angular/core";
import {OnDestroy} from "@angular/core";

declare var jQuery: any;

@Directive({
    selector: '[wFocusInput]'
})
export class WFocusInput implements AfterViewInit, OnInit, OnDestroy {

    firstTime: boolean = true;
    @Input()
    modalObject: ModalDirective = null;

    constructor(public elem: ElementRef) {
    }

    ngOnInit() {
        if (this.modalObject !== null) {
            this.modalObject.onShown.subscribe(() => {
                let item = jQuery(this.elem.nativeElement);
                if ((item.is("input") || item.is("textarea") || item.prop('contenteditable') == 'true') && item.is(":visible")) {
                    item.focus();
                    try {
                        item.select();
                    } catch (e) {
                    }
                }
                else {
                    item = jQuery(this.elem.nativeElement).find("input[type=text]:visible");
                    if (item.length > 0) {
                        try {
                            item[0].focus();
                            item[0].select();
                        } catch (e) {
                        }
                    }
                    else {
                        item = jQuery(this.elem.nativeElement).find("div[contenteditable='true']");
                        if (item.length > 0) {
                            item[0].focus();
                            //item[0].select();
                        }
                    }
                }
            });
        }
    }

    ngAfterViewInit() {
        if (this.firstTime) {
            if (this.modalObject == null) {
                let item = jQuery(this.elem.nativeElement);
                if ((item.is("input") || item.is("textarea") || item.prop('contenteditable') == 'true') && item.is(":visible")) {
                    item.focus();
                    try {
                        item.select();
                    } catch (e) {
                    }
                }
                else {
                    item = jQuery(this.elem.nativeElement).find("input[type=text]:visible");
                    if (item.length > 0) {
                        try {
                            item[0].focus();
                            item[0].select();
                        } catch (e) {
                        }
                    }
                    else {
                        item = jQuery(this.elem.nativeElement).find("div[contenteditable='true']");
                        if (item.length > 0) {
                            item[0].focus();
                            //item[0].select();
                        }
                    }
                }
            }
        }
        this.firstTime = false;
    }

    ngOnDestroy() {
        /*
         if (this.modalObject !== null) {
         try {
         << Ez kiakasztja, de miért? >>
         this.modalObject.onShown.unsubscribe();
         } catch (e) {
         }
         }*/
    }

}

@NgModule({
    imports: [CommonModule],
    exports: [WFocusInput],
    declarations: [WFocusInput]
})
export class WFocusInputModule {
}
